<template>
  <Carousel 
    :value="vocabularyDetails" 
    :num-visible="1" 
    :num-scroll="1"
    :show-indicators="false"
    class="vocabulary-meaning-card"
  >
    <template #item="{ data: slotData, index: slotIndex }">
      <div class="vocab-card border border-surface-200 dark:border-surface-700 rounded m-2">
        <div class="word-section">
          <div class="word">
            {{ slotData.word }}
          </div>
          <div class="word-reading">
            {{ slotData.reading }}
          </div>
        </div>
        <p class="meaning">
          {{ formatWordMeaning(slotData.english_meaning) }}
        </p>
        <div class="card-footer">
          <Tag 
            v-if="slotData.jlpt?.length > 0"
            severity="warn"
            class="jlpt-tag"
          > 
            {{ slotData.jlpt?.join(', ') }}
          </Tag>
          <div class="save-btn-wrapper">
            <Button 
              v-if="!slotData.saved_word"
              :data-test="`save-vocab-btn-${groupIndex}-${slotIndex}`"
              icon="pi pi-bookmark" 
              severity="secondary" 
              variant="outlined"
              @click="saveWord(slotData)"
            />
            <Button 
              v-else
              icon="pi pi-bookmark-fill" 
              severity="secondary" 
              variant="outlined"
            />
          </div>
        </div>
      </div>
    </template>
  </Carousel>
</template>

<script>
import Carousel from 'primevue/carousel';
import Tag from 'primevue/tag';
import Button from 'primevue/button';
import { postWithAuthentication } from "@/services/api";
import {
    BASE_URL,
    SAVE_WORD_ENDPOINT,
} from "@/assets/constants/api_endpoints";
import {
    SAVE_WORD_SUCCESS_MSG,
    SAVE_WORD_FAILED_ERR_MSG,
    SUCCESS_STATUS,
    FAILED_STATUS,
} from "@/assets/constants/constants";

export default {
    name: "VocabularyMeaningCard",
    components: {
        Carousel,
        Tag,
        Button
    },
    props: {
        vocabularyDetails: {
            type: Array,
            required: true
        },
        groupIndex: {
            type: Number,
            default: 0
        }
    },
    methods: {
      formatWordMeaning(wordMeaning) {
        return  wordMeaning?.join(" ,").replaceAll(',', ', ')
      },
      async saveWord(vocabulary) {
        try {
            let jlpt = "";
            if (vocabulary.jlpt?.length > 0) {
              jlpt = vocabulary.jlpt[0];
            }
            let definition = [];
            if (vocabulary.english_meaning?.length > 0) {
              definition = vocabulary.english_meaning[0];
            }
            if (vocabulary.word === null || vocabulary.word === undefined) {
              vocabulary.word = vocabulary.reading;
            }
            const resource = this.$store.state.readerDocument || {};
            const payload = {
                word: vocabulary.word,
                definition: definition.join(', '),
                jlpt: jlpt,
                reading: vocabulary.reading,
                resource_id: resource.id.toString(),
                subject_id: resource.subject_id?.toString(),
                is_sample: resource.is_sample,
            }
            const response = await postWithAuthentication(
                BASE_URL,
                SAVE_WORD_ENDPOINT,
                payload
            );
            this.showInfoNotification(SUCCESS_STATUS, SAVE_WORD_SUCCESS_MSG);
            vocabulary.saved_word = true;
        } catch (error) {
            this.showInfoNotification(FAILED_STATUS, SAVE_WORD_FAILED_ERR_MSG);
        }
      },
      showInfoNotification(status, message) {
          this.$toast.add({ severity: status, summary: message, life: 3000 });
      },

    }
}
</script>

<style scoped>
.vocabulary-meaning-card {
    margin: 0 0 20px 0;
    width: 100%;
    box-sizing: border-box;
}

:deep(.p-carousel),
:deep(.p-carousel-content),
:deep(.p-carousel-items-container) {
    width: 100%;
    box-sizing: border-box;
}

:deep(.p-carousel-item) {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: stretch;
}

:deep(.p-carousel-items-content) {
    display: flex;
    align-items: stretch;
}

:deep(.p-carousel-prev),
:deep(.p-carousel-next),
:deep(.p-carousel-indicators) {
    display: none;
}

.vocab-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px 24px;
    height: 100%;
    box-sizing: border-box;
}

.word-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.word {
    font-size: 18px;
    font-weight: 600;
}

.word-reading {
    font-family: 'Courier New', Courier, monospace;
    font-size: 13px;
    color: rgb(92, 74, 102);
}

.meaning {
    flex: 1;
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
    color: var(--p-text-muted-color, #555);
}

.card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--p-surface-200, #e5e7eb);
}

.save-btn-wrapper {
    margin-left: auto;
}
</style>